import React from 'react'

import { Card } from '@application/Interfaces/Features/TitleDescriptionCards/Card/Card'
import { TitleDescriptionCardsType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import { Link } from '@src/Application/Interfaces/Atoms/Link'

import { Button, TitleSection } from './TitleDescriptionCards.styled'

export const TitleDescriptionCards = ({
    title,
    subtitle,
    mode,
    titleDescriptionCardItems,
    buttonLink,
    buttonLabel,
}: TitleDescriptionCardsType): JSX.Element => {
    return (
        <TitleSection title={title} subtitle={subtitle} mode={mode}>
            <Grid container columnSpacing={6} rowSpacing={{ xs: 5, md: 10 }}>
                {titleDescriptionCardItems.map((item, i) => (
                    <Grid item xs={12} md={item.fullWidth ? 12 : 6} key={`${item.title}-${i}`}>
                        <Card {...item} />
                    </Grid>
                ))}
                {buttonLabel && buttonLink && (
                    <Grid item xs={12} textAlign="center">
                        <Link to={buttonLink}>
                            <Button mode={mode}>{buttonLabel}</Button>
                        </Link>
                    </Grid>
                )}
            </Grid>
        </TitleSection>
    )
}
